<template>
  <section class="flex md:justify-between items-center pt-6 pb-4 first:border-transparent border-t border-black pl-1 text-sm">
    <section>
      <section class="md:flex items-center gap-x-3">
        <section class="flex gap-x-3">
          <section class="flex flex-col items-center">
            <article class="flex items-center gap-x-2">
              <icon
                :name="'clock'"
                :width="19"
                :height="19"
                :color="'skin-icon-tertiary'"
              />
              <p v-text="'Hora de inicio'" />
            </article>
            <p class="opacity-50" v-text="schedule.init" />
          </section>
          <section>
            <p v-text="'Hora de fin'" />
            <p class="opacity-50" v-text="schedule.end" />
          </section>
        </section>
      </section>
      <section class="my-2">
        <p class="text-xs" v-text="schedule.module.name" />
      </section>
    </section>
    <button
      class="rounded-xl shadow-sm px-4 py-2.5 text-skin-blueCambiando bg-white ml-2"
      v-text="'Postular'" @click="$emit('requestMentory', schedule.id)"
    />
  </section>
</template>
<script>
export default {
  props:{
    schedule:{
      require: true
    },
  },
  components: {
    Icon: () => import("../components/Icon.vue"),
  },
};
</script>
